import React from "react";
import { withStyles } from "@material-ui/core";
import { compose } from "recompose";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import Clear from "@material-ui/icons/CancelOutlined";
import { fade } from "@material-ui/core/styles/colorManipulator";

const styles = (theme) => ({
  searchContainer: {
    display: "inline-block",
    position: "relative",
    marginRight: 10,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.AppBGColor, 0.25),
    "&:hover": {
      backgroundColor: fade(theme.HeaderBGColor, 0.15),
    },
    marginLeft: 0,
    marginTop: 2,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing.unit,
      width: "auto",
    },
  },
  searchInputRoot: {
    color: "inherit",
    width: "100%",
    height: 32,
    fontSize: 14,
  },
  searchInput: {
    color: theme.iconColor,
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 10,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: 120,
      "&:focus": {
        width: 200,
      },
    },
  },
  searchIcon: {
    color: theme.iconColor,
    width: theme.spacing.unit * 9,
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  clearIcon: {
    paddingRight: "5px",
  },
  iconHidden: {
    visibility: "hidden",
  },
  iconVisible: {
    visibility: "visible",
    color: theme.iconColor,
    cursor: "pointer",
    paddingRight: "5px",
  },
});

class SearchBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputText: "",
    };
  }
  onChange = (event) => {
    this.setState({
      inputText: event.target.value,
    });
    this.props.onChange(event.target.value);
  };

  render() {
    const { classes } = this.props;
    return (
      <span className={classes.searchContainer}>
        <div className={classes.searchIcon}>
          <SearchIcon />
        </div>
        <InputBase
          placeholder="Search…"
          classes={{
            root: classes.searchInputRoot,
            input: classes.searchInput,
          }}
          onChange={this.onChange}
          value={this.state.inputText}
          endAdornment={
            <Clear
              classes={{
                root: `${classes.clearIcon} ${
                  this.state.inputText
                    ? classes.iconVisible
                    : classes.iconHidden
                }`,
              }}
              onClick={() =>
                this.onChange({ target: { value: "" } })
              }
              display={this.state.inputText ? "none" : "block"}
            />
          }
        />
      </span>
    );
  }
}
export default compose(withStyles(styles))(SearchBox);
